import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full px-4 md:px-6 py-20 md:py-24 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Abstract%20warm%20peach%20gradient%20flowing%20silk%20texture%20with%20soft%20golden%20light%20highlights%2C%20elegant%20smooth%20waves%2C%20warm%20inviting%20atmosphere%2C%20luxurious%20abstract%20art%20with%20dreamy%20soft%20focus&width=1920&height=600&seq=cta-bg-01&orientation=landscape')`,
        }}
      >
      </div>
      <div className="absolute inset-0 bg-black/30"></div>

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-background-50 mb-4">
          准备好开始<strong>全新体验</strong>了吗？
        </h2>
        <p className="text-sm text-background-50/70 mb-8 max-w-md mx-auto">
          加入蜜桃在线，畅享极速、稳定、安全的在线娱乐服务。数百万用户的选择，现在就加入我们！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category"
            className="px-8 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            立即免费体验
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 text-sm font-medium hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}